import React, {FC, useEffect, useRef, useState} from 'react';

import BackButton from '../../../../../components/BackButton/BackButton';
import AppButton from '../../../../../components/Button/AppButton/AppButton';
import Carousel from '../../../../../components/Carousel/Carousel';
import Image from '../../../../../components/Image/Image';
import Container from '../../../../../components/Layout/Container/Container';
import * as localizationKeys from '../../../../../consts/localization/localizationKeys';
import analyticsService from '../../../../../services/analyticsService';
import connectivityService from '../../../../../services/device/connectivityService';
import iqosHidService from '../../../../../services/hid/iqosHidService';
import {getLocalizedStrings} from '../../../../../services/localization/localizationService';
import log from '../../../../../services/logger/log';
import {setNotificationSuccess} from '../../../../../state/ducks/global';
import {setFWUSuccess} from '../../../../../state/ducks/iotDevice/actions';
import {dispatch} from '../../../../../state/store';
import elementsTesIds from '../../../../../test/consts/elementsTesIds';
import UpdateFWPageTemplate from '../../../../UpdateFWPage/components/UpdateFWPageTemplate';
import {fwuAdditionalStepsGuideData} from './FWUAdditionalStepsGuideData';

interface IProps {
    onBackButtonClick: () => void;
    onClose: () => void;
}

const FWUAdditionalStepsGuide: FC<IProps> = (props) => {
    const {onBackButtonClick, onClose} = props;
    const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
    const localizedStrings = getLocalizedStrings();
    const isBle = connectivityService.isBle();
    const slider: any = useRef();
    const totalStepsCount = fwuAdditionalStepsGuideData?.length;

    const onContinue = async (isLast: boolean) => {
        if (isLast) {
            try {
                onClose();
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                await iqosHidService.connect({
                    onConnect: () => {
                        dispatch(
                            setNotificationSuccess({textKey: localizationKeys.IQOS_DUO_FIRMWARE_UPDATE_SUCCESS} as any)
                        );
                        dispatch(setFWUSuccess());
                    },
                });
            } catch (e) {
                log.info(e);
            }
        } else if (slider?.current?.slide) {
            slider.current.next();
        }
    };

    useEffect(() => {
        analyticsService.pushSpecialFlowGuide();
    }, []);

    const isLastSlideVisible = currentSlideIndex === totalStepsCount - 1;

    useEffect(() => {
        if (isLastSlideVisible) {
            analyticsService.pushFinalizingYourFirmwareUpgrade();
        }
    }, [isLastSlideVisible]);

    const onSlide = (index: number) => {
        setCurrentSlideIndex(index);
    };

    return (
        <>
            {!isBle && (
                <Container className='left-0 transform-none' isFloatHeight>
                    <BackButton
                        className='left-8 top-4 md:left-[60px]'
                        ariaLabel={
                            localizedStrings[
                                localizationKeys.FWU_ADDITIONAL_STEPS_GUIDE_BTN_BACK_TO_ABOUT_DEVICE_ARIA_LABEL
                            ]
                        }
                        onClick={onBackButtonClick}
                        testId={elementsTesIds.ABOUT_DEVICE_BTN_BACK}
                    />
                </Container>
            )}
            <Carousel isArrowVisible={false} isDotsVisible={false} ref={slider} onTransitionEnd={onSlide}>
                {fwuAdditionalStepsGuideData.map(
                    (element: {images: string | Array<string>; header: string; description: string}, index: number) => {
                        const {header, description, images} = element;
                        const isLast = totalStepsCount - index === 1;

                        return (
                            <div key={index}>
                                <UpdateFWPageTemplate
                                    imageSrcList={images}
                                    current={index + 1}
                                    total={totalStepsCount}
                                    titleKey={header}
                                    isCountVisible={!isLast}
                                    rightSectionChildren={
                                        <Image className='h-full w-full object-contain' src={images} />
                                    }
                                >
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: localizedStrings[description],
                                        }}
                                    />
                                    <AppButton primary light className='mt-10' onClick={() => onContinue(isLast)}>
                                        {localizedStrings[localizationKeys.IQOS_DUO_STEPS_BUTTON_TEXT]}
                                    </AppButton>
                                </UpdateFWPageTemplate>
                            </div>
                        );
                    }
                )}
            </Carousel>
        </>
    );
};

export default FWUAdditionalStepsGuide;
